/* eslint-disable react/require-default-props */
import { clsx } from "clsx";

type Props = {
  label: string;
  icon: any;
  additionalClasses?: string;
  onClick?: any;
  labelClasses?: string;
  isDisabled?: boolean;
};

function ButtonWithIcon({ label, icon, additionalClasses, onClick, labelClasses, isDisabled }: Props) {
  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onClick}
      className={`relative inline-flex items-center space-x-2 rounded-full border 
      border-white bg-primary px-4  py-2 text-white hover:opacity-50
      disabled:opacity-50  ${additionalClasses}`}
    >
      <div className="h-full">{icon}</div>
      <div className={clsx("font-satoshi font-450 opacity-100", labelClasses)}>{label}</div>
    </button>
  );
}
export default ButtonWithIcon;
